import { render } from "./PressearchivView.vue?vue&type=template&id=460c1887&scoped=true"
import script from "./PressearchivView.vue?vue&type=script&lang=js"
export * from "./PressearchivView.vue?vue&type=script&lang=js"

import "./PressearchivView.vue?vue&type=style&index=0&id=460c1887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460c1887"]])

export default __exports__